module.exports = __webpack_public_path__ + "d85357f8f7b556d1b9f8888763b34b43.png";